import { HttpClient } from '@angular/common/http';
import { Validators } from '@angular/forms';
import { FORMLY_FIELD_TYPES, FORMLY_FIELD_VALIDATORS, FORMLY_FIELD_WRAPPERS, Masks } from '@app/constants';
import { Patterns } from '@app/constants/patterns.constant';
import { LoadingService } from '@app/core/services';
import { Validations } from '.';
import { addonsExtension } from './addons.extension';
import { FormlyWrapperAddonsComponent } from './addons.wrapper';
import {
	AccountFilterComponent,
	AccountRangeTableComponent,
	BasicWrapperComponent,
	CustomPanelWithTitleWrapperComponent,
	CustomWrapperComponent,
	DeductionGradingTableComponent,
	FieldElementRangeComponent,
	FormGroupRepeatComponent,
	FormlyAccountPercentageRepeatComponent,
	FormlyAutocompleteTypeComponent,
	FormlyDateRangeTypeComponent,
	FormlyDecimalInputComponent,
	FormlyFieldHeaderLabelComponent,
	FormlyImagePreviewComponent,
	FormlyKababComponent,
	FormlyMaskedInputComponent,
	FormlyMatButtonComponent,
	FormlyMessageListComponent,
	FormlyMicrInputComponent,
	FormlyMultiSelectChipsComponent,
	FormlyPositiveIntegersInputComponent,
	FormlyRepeatTypeComponent,
	FormlyRoleFieldClaimsComponent,
	FormlyRoleSectionPermissionsComponent,
	FormlySpinnerComponent,
	FormlyTableComponent,
	FormlyTabsComponent,
	FormlyToggleInputComponent,
	MatCardWrapperComponent,
	MatExpansionPanelWrapperComponent,
	MultiuseSearchInputComponent,
	PanelDefaultWrapperComponent,
	PlainTextInputComponent,
	PrGradingTableComponent,
	SectionAccordionWrapperComponent,
	SectionReportFieldWrapperComponent,
	SectionReportWrapperComponent,
	SectionSimpleTitleWrapperComponent,
	SectionSimpleWrapperComponent,
	SectionSingleFieldWrapperComponent,
	SectionWrapperComponent,
	TooltipComponent,
	UibDropdownComponent,
	VerticalSpacerComponent,
} from './components';
import { FormlyAccountAutocompleteTypeComponent } from './components/account-autocomplete.type';
import { FormlyFieldButtonComponent } from './components/button-type.component';
import { FormlyChipListComponent } from './components/chip-list-type.component';
import { FormlyDatepickerTypeComponent } from './components/datepicker-type.component';
import { FormlyTemplateComponent } from './components/formly-template.component';
import { FormlyMultiCheckboxComponent } from './components/multi-checkbox/multi-checkbox.component';
import { FormlyMultiselectAllComponent } from './components/multiselect-all/multiselect-all.component';
import { MultiselectAutocompleteComponent } from './components/multiselect-autocomplete/multiselect-autocomplete.component';
import { SelectSearchComponent } from './components/select-search/select-search.component';
import { SelectWithModalComponent } from './components/select-with-modal/select-with-modal.type';
import { FormlyTimePickerComponent } from './components/time-picker/time-picker.component';
import { VendorAutocompleteComponent } from './components/vendor-autocomplete/vendor-autocomplete.component';
import { PlainTextWrapperComponent } from './plaintext.wrapper';

export const generateFormlyConfig = (http: HttpClient, loadingService: LoadingService): any => ({
	types: [
		{
			name: FORMLY_FIELD_TYPES.autocomplete,
			component: FormlyAutocompleteTypeComponent,
			wrappers: [FORMLY_FIELD_WRAPPERS.formField],
		},
		{
			name: FORMLY_FIELD_TYPES.accountAutocomplete,
			component: FormlyAccountAutocompleteTypeComponent,
			wrappers: [FORMLY_FIELD_WRAPPERS.formField],
		},
		{
			name: FORMLY_FIELD_TYPES.button,
			component: FormlyFieldButtonComponent,
			wrappers: [FORMLY_FIELD_WRAPPERS.formField],
			defaultOptions: {
				templateOptions: {
					btnType: 'default',
					type: 'button',
				},
			},
		},
		{ name: FORMLY_FIELD_TYPES.datepickerRange, component: FormlyDateRangeTypeComponent, wrappers: [FORMLY_FIELD_WRAPPERS.formField] },
		{
			name: FORMLY_FIELD_TYPES.multiCheckbox,
			component: FormlyMultiCheckboxComponent,
		},
		{
			name: FORMLY_FIELD_TYPES.multiSelectAutocomplete,
			component: MultiselectAutocompleteComponent,
		},
		{
			name: FORMLY_FIELD_TYPES.multiSelectAll,
			component: FormlyMultiselectAllComponent,
		},
		{
			name: FORMLY_FIELD_TYPES.multiSelectChips,
			component: FormlyMultiSelectChipsComponent,
		},
		{
			name: FORMLY_FIELD_TYPES.multiuseSearchInput,
			component: MultiuseSearchInputComponent,
		},
		{
			name: FORMLY_FIELD_TYPES.timePicker,
			component: FormlyTimePickerComponent,
		},
		{ name: FORMLY_FIELD_TYPES.decimalInput, component: FormlyDecimalInputComponent, wrappers: [FORMLY_FIELD_WRAPPERS.formField] },
		{ name: FORMLY_FIELD_TYPES.headerLabel, component: FormlyFieldHeaderLabelComponent },
		{ name: FORMLY_FIELD_TYPES.formlySpinner, component: FormlySpinnerComponent },
		{ name: FORMLY_FIELD_TYPES.formlyMessageList, component: FormlyMessageListComponent },
		{ name: FORMLY_FIELD_TYPES.maskedInput, component: FormlyMaskedInputComponent, wrappers: [FORMLY_FIELD_WRAPPERS.formField] },
		{
			name: FORMLY_FIELD_TYPES.inputPositiveIntegers,
			component: FormlyPositiveIntegersInputComponent,
			wrappers: [FORMLY_FIELD_WRAPPERS.formField],
		},
		{
			name: FORMLY_FIELD_TYPES.micrInput,
			component: FormlyMicrInputComponent,
			wrappers: [FORMLY_FIELD_WRAPPERS.formField],
		},
		{ name: FORMLY_FIELD_TYPES.repeat, component: FormlyRepeatTypeComponent },
		{ name: FORMLY_FIELD_TYPES.formGroupRepeat, component: FormGroupRepeatComponent },
		{ name: FORMLY_FIELD_TYPES.template, component: FormlyTemplateComponent },
		{ name: FORMLY_FIELD_TYPES.toggle, component: FormlyToggleInputComponent },
		{ name: FORMLY_FIELD_TYPES.chipList, component: FormlyChipListComponent },
		{ name: FORMLY_FIELD_TYPES.formlyTable, component: FormlyTableComponent },
		{ name: FORMLY_FIELD_TYPES.formlyTabs, component: FormlyTabsComponent },
		{ name: FORMLY_FIELD_TYPES.formlyKabab, component: FormlyKababComponent },
		{ name: FORMLY_FIELD_TYPES.formlyMatButton, component: FormlyMatButtonComponent },
		{ name: FORMLY_FIELD_TYPES.accountPercentageRepeat, component: FormlyAccountPercentageRepeatComponent },
		{ name: FORMLY_FIELD_TYPES.deductionGradingTable, component: DeductionGradingTableComponent },
		{ name: FORMLY_FIELD_TYPES.elementRange, component: FieldElementRangeComponent },
		{ name: FORMLY_FIELD_TYPES.accountRangeTable, component: AccountRangeTableComponent },
		{ name: FORMLY_FIELD_TYPES.uibDropdown, component: UibDropdownComponent },
		{ name: FORMLY_FIELD_TYPES.tooltip, component: TooltipComponent },
		{
			name: FORMLY_FIELD_TYPES.accountFilter,
			component: AccountFilterComponent,
			wrappers: [FORMLY_FIELD_WRAPPERS.formField],
			defaultOptions: {
				templateOptions: {
					patterns: { 0: { pattern: new RegExp(Patterns.numericAccount) } },
					dropSpecialCharacter: false,
					showMask: true,
					dropCustomValues: true,
				},
			},
		},
		{ name: FORMLY_FIELD_TYPES.verticalSpacer, component: VerticalSpacerComponent },
		{ name: FORMLY_FIELD_TYPES.plainText, component: PlainTextInputComponent, wrappers: [FORMLY_FIELD_WRAPPERS.plaintext] },
		{
			name: FORMLY_FIELD_TYPES.zipInput,
			extends: FORMLY_FIELD_TYPES.maskedInput,
			defaultOptions: {
				templateOptions: {
					mask: Masks.Zip,
					maxLength: 10,
					dropSpecialCharacters: false,
				},
			},
		},
		{
			name: FORMLY_FIELD_TYPES.ssnInput,
			extends: FORMLY_FIELD_TYPES.maskedInput,
			defaultOptions: {
				templateOptions: {
					mask: Masks.SSN,
					maxLength: 11,
					dropSpecialCharacters: true,
				},
			},
		},
		{
			name: FORMLY_FIELD_TYPES.decimal2Input,
			extends: FORMLY_FIELD_TYPES.maskedInput,
			defaultOptions: {
				templateOptions: {
					mask: Masks.Decimal2WithSeparator,
					dropSpecialCharacters: true,
					thousandSeparator: ',',
				},
			},
		},
		{
			name: FORMLY_FIELD_TYPES.decimal4Input,
			extends: FORMLY_FIELD_TYPES.maskedInput,
			defaultOptions: {
				templateOptions: {
					mask: Masks.Decimal4WithSeparator,
					dropSpecialCharacters: true,
					thousandSeparator: ',',
				},
			},
		},
		{
			name: FORMLY_FIELD_TYPES.negativeDecimal2Input,
			extends: FORMLY_FIELD_TYPES.decimal2Input,
			defaultOptions: {
				templateOptions: {
					allowNegativeNumbers: true,
				},
			},
		},
		{
			name: FORMLY_FIELD_TYPES.percentageInput,
			extends: FORMLY_FIELD_TYPES.maskedInput,
			defaultOptions: {
				templateOptions: {
					mask: Masks.Decimal2,
					type: 'number',
					max: 100,
					min: 0,
					step: 0.1,
				},
			},
		},
		{
			name: FORMLY_FIELD_TYPES.accountInput,
			extends: FORMLY_FIELD_TYPES.maskedInput,
			defaultOptions: {
				templateOptions: {
					mask: Masks.Account,
					patterns: { 0: { pattern: new RegExp('[\\d\\?]') } },
				},
			},
		},
		{
			name: FORMLY_FIELD_TYPES.vendorAutocomplete,
			component: VendorAutocompleteComponent,
		},
		{ name: FORMLY_FIELD_TYPES.prGradingTable, component: PrGradingTableComponent },
		{ name: FORMLY_FIELD_TYPES.appDatepicker, component: FormlyDatepickerTypeComponent },
		{ name: FORMLY_FIELD_TYPES.appSelectModal, component: SelectWithModalComponent },
		{ name: FORMLY_FIELD_TYPES.selectSearch, component: SelectSearchComponent },
		{ name: FORMLY_FIELD_TYPES.imagePreview, component: FormlyImagePreviewComponent },
		{ name: FORMLY_FIELD_TYPES.roleSectionPermissions, component: FormlyRoleSectionPermissionsComponent },
		{ name: FORMLY_FIELD_TYPES.roleFieldClaims, component: FormlyRoleFieldClaimsComponent },
	],
	validators: [
		{
			name: FORMLY_FIELD_VALIDATORS.duplicate,
			validation: Validations.duplicateValidator,
		},
		{
			name: FORMLY_FIELD_VALIDATORS.phoneNumber,
			validation: Validations.phoneNumberValidator,
		},
		{
			name: FORMLY_FIELD_VALIDATORS.email,
			validation: Validators.email,
		},
		{
			name: FORMLY_FIELD_VALIDATORS.maxDecimalPlaces,
			validation: Validations.maxDecimalPlacesValidator,
		},
		{
			name: FORMLY_FIELD_VALIDATORS.requiredNoWhitespace,
			validation: Validations.whiteSpaceValidator,
		},
		{
			name: FORMLY_FIELD_VALIDATORS.hasBegEndWhitespace,
			validation: Validations.hasBegEndWhiteSpaceValidator,
		},
		{
			name: FORMLY_FIELD_VALIDATORS.lettersOnly,
			validation: Validations.lettersOnlyValidator,
		},
		{
			name: FORMLY_FIELD_VALIDATORS.notGreaterThanZero,
			validation: Validations.notGreaterThanZeroValidator,
		},
		{
			name: FORMLY_FIELD_VALIDATORS.duplicateAsync,
			validation: Validations.duplicateAsyncValidator(http, loadingService),
			options: {
				url: '',
			},
		},
		{
			name: FORMLY_FIELD_VALIDATORS.match,
			validation: Validations.matchValidator,
			options: {
				fields: [],
			},
		},
		{
			name: FORMLY_FIELD_VALIDATORS.routingNumber,
			validation: Validations.routingNumberValidator,
		},
	],
	validationMessages: [
		{ name: FORMLY_FIELD_VALIDATORS.duplicate, message: Validations.duplicateValidationMessage },
		{ name: FORMLY_FIELD_VALIDATORS.email, message: Validations.emailValidationMessage },
		{ name: 'required', message: Validations.requiredValidationMessage },
		{ name: 'minLength', message: Validations.minLengthValidationMessage },
		{ name: 'maxLength', message: Validations.maxLengthValidationMessage },
		{ name: 'min', message: Validations.minValidationMessage },
		{ name: 'max', message: Validations.maxValidationMessage },
		{ name: FORMLY_FIELD_VALIDATORS.minTime, message: Validations.minTimeValidationMessage },
		{ name: FORMLY_FIELD_VALIDATORS.maxTime, message: Validations.maxTimeValidationMessage },

		{ name: FORMLY_FIELD_VALIDATORS.maxDecimalPlaces, message: Validations.maxDecimalPlacesValidationMessage },
		{ name: FORMLY_FIELD_VALIDATORS.requiredNoWhitespace, message: Validations.requiredValidationMessage },
		{ name: 'matDatepickerMin', message: Validations.minDateValidationMessage },
		{ name: 'matDatepickerMax', message: Validations.maxDateValidationMessage },
		{ name: FORMLY_FIELD_VALIDATORS.mask, message: Validations.maskValidationMessage },
		{ name: FORMLY_FIELD_VALIDATORS.hasBegEndWhitespace, message: Validations.hasBegEndWhitespaceMessage },
		{ name: FORMLY_FIELD_VALIDATORS.notGreaterThanZero, message: Validations.notGreaterThanZeroMessage },
		{ name: FORMLY_FIELD_VALIDATORS.lettersOnly, message: Validations.lettersOnlyMessage },

		{ name: FORMLY_FIELD_VALIDATORS.phoneNumber, message: Validations.phoneNumberValidationMessage },

		{
			name: FORMLY_FIELD_VALIDATORS.duplicateAsync,
			message: Validations.duplicateAsyncMessage,
		},
		{
			name: FORMLY_FIELD_VALIDATORS.match,
			message: Validations.matchMessage,
		},
		{ name: FORMLY_FIELD_VALIDATORS.routingNumber, message: Validations.routingNumberMessage },
	],
	wrappers: [
		{ name: FORMLY_FIELD_WRAPPERS.section, component: SectionWrapperComponent },
		{ name: FORMLY_FIELD_WRAPPERS.sectionAccordion, component: SectionAccordionWrapperComponent },
		{ name: FORMLY_FIELD_WRAPPERS.sectionSimple, component: SectionSimpleWrapperComponent },
		{ name: FORMLY_FIELD_WRAPPERS.sectionSimpleTitle, component: SectionSimpleTitleWrapperComponent },
		{ name: FORMLY_FIELD_WRAPPERS.sectionSingleField, component: SectionSingleFieldWrapperComponent },
		{ name: FORMLY_FIELD_WRAPPERS.customPanelWithTitle, component: CustomPanelWithTitleWrapperComponent },
		{ name: FORMLY_FIELD_WRAPPERS.basicWrapper, component: BasicWrapperComponent },
		{ name: FORMLY_FIELD_WRAPPERS.customWrapper, component: CustomWrapperComponent },
		{ name: FORMLY_FIELD_WRAPPERS.addons, component: FormlyWrapperAddonsComponent },
		{ name: FORMLY_FIELD_WRAPPERS.plaintext, component: PlainTextWrapperComponent },
		{ name: FORMLY_FIELD_WRAPPERS.reportWrapper, component: SectionReportWrapperComponent },
		{ name: FORMLY_FIELD_WRAPPERS.reportFieldWrapper, component: SectionReportFieldWrapperComponent },
		{ name: FORMLY_FIELD_WRAPPERS.panelDefaultWrapper, component: PanelDefaultWrapperComponent },
		{ name: FORMLY_FIELD_WRAPPERS.matCardWrapper, component: MatCardWrapperComponent },
		{ name: FORMLY_FIELD_WRAPPERS.matExpansionPanelWrapper, component: MatExpansionPanelWrapperComponent },
	],
	extensions: [{ name: 'addons', extension: { onPopulate: addonsExtension } }],
	extras: { lazyRender: true },
});
